export type AttendanceStatus =
  | 'Present'
  | 'Late'
  | 'Cancelled - 1+ days notice'
  | 'Cancelled - same day'
  | 'Absent';

export const ABSENT_STATUSES: AttendanceStatus[] = [
  'Absent',
  'Cancelled - 1+ days notice',
  'Cancelled - same day',
];

export const MODAL_STATUSES: AttendanceStatus[] = [
  'Late',
  'Cancelled - 1+ days notice',
  'Cancelled - same day',
  'Absent',
];

/**
 * What the register means for the session in Orbit when the tutor presses Submit: AwaitReport = learning
 * took place, the report is submitted and payment authorised; Authorised = nobody attended, paid with no
 * report content; Cancelled = every learner gave 1+ days notice, the Orbit session is cancelled and the
 * tutor is not paid. The register submit itself settles nothing — it only saves and locks the register.
 */
export type SessionOutcome = 'AwaitReport' | 'Authorised' | 'Cancelled';

const ATTENDED_STATUSES: AttendanceStatus[] = ['Present', 'Late'];

/**
 * UI mirror of the server's outcome rule, used ONLY to pick the Submit confirm-dialog wording before the
 * POST — the server resolves the real outcome from the saved register and its response is authoritative.
 */
export function resolveSessionOutcome(statuses: AttendanceStatus[], tutorCancelled: boolean): SessionOutcome {
  if (tutorCancelled) return 'Cancelled';
  if (statuses.length === 0) return 'AwaitReport';
  if (statuses.some(status => ATTENDED_STATUSES.includes(status))) return 'AwaitReport';
  if (statuses.every(status => status === 'Cancelled - 1+ days notice')) return 'Cancelled';
  return 'Authorised';
}

export interface StudentAttendance {
  studentId: string;
  status: AttendanceStatus;
  reason?: string;
  comments?: string;
  parentCarerInformed?: string;
}

export interface AttendanceDialogData {
  studentName: string;
  status: AttendanceStatus;
}

export interface AttendanceDialogResult {
  reason?: string;
  comments: string;
  parentCarerInformed?: string;
}

export interface TutorCancelledDialogResult {
  reason: string;
  comments: string;
}

export interface BehaviouralConcernDialogResult {
  reason: string;
  comments: string;
}

/** One concern per student per session: `existingConcern` set means the dialog opens read-only. */
export interface BehaviouralConcernDialogData {
  studentName: string;
  existingConcern: BehaviouralConcernDialogResult | null;
}

export interface ConsultantNotesDialogData {
  studentName?: string;
  existingNotes?: string;
}
